import {
  Shield, Flag, GraduationCap, Trophy, Users, Wallet, FileText, Package, Target, Mail, Settings,
  AlertCircle, AlertTriangle, Info,
} from 'lucide-react';
import api from '../../../services/api';

export const DOMAINS = [
  { key: 'departs', label: 'Départs', icon: Flag, color: 'text-emerald-600' },
  { key: 'academie', label: 'Cours & Académie', icon: GraduationCap, color: 'text-sky-600', views: [['alertes', 'Alertes'], ['as', 'Refacturation AS']] },
  { key: 'evenements', label: 'Événements', icon: Trophy, color: 'text-amber-600' },
  { key: 'clients', label: 'Cotisations & Clients', icon: Users, color: 'text-violet-600' },
  { key: 'caisse', label: 'Caisse', icon: Wallet, color: 'text-teal-600', views: [['alertes', 'Alertes'], ['suivi', 'Suivi des acomptes']] },
  { key: 'factures', label: 'Factures', icon: FileText, color: 'text-rose-600' },
  { key: 'taylormade', label: 'TaylorMade', icon: Package, color: 'text-orange-600' },
  { key: 'practice', label: 'Practice', icon: Target, color: 'text-lime-600' },
  { key: 'emails', label: 'Emails', icon: Mail, color: 'text-cyan-600' },
  { key: 'systeme', label: 'Système', icon: Settings, color: 'text-slate-500' },
];
export const OVERVIEW = { key: 'all', label: "Vue d'ensemble", icon: Shield, color: 'text-neutral-700' };
export const domainOf = (key) => DOMAINS.find((d) => d.key === key);

export const SEVERITY = {
  critical: { label: 'Critique', icon: AlertCircle, border: 'border-red-200', bg: 'bg-red-50/60', pill: 'bg-red-100 text-red-700', text: 'text-red-600', order: 0 },
  warning: { label: 'Attention', icon: AlertTriangle, border: 'border-amber-200', bg: 'bg-amber-50/60', pill: 'bg-amber-100 text-amber-800', text: 'text-amber-600', order: 1 },
  info: { label: 'Info', icon: Info, border: 'border-blue-200', bg: 'bg-blue-50/60', pill: 'bg-blue-100 text-blue-700', text: 'text-blue-600', order: 2 },
};

export const PERIODS = [
  { key: 'all', label: 'Toutes dates' },
  { key: 'today', label: "Aujourd'hui" },
  { key: '7d', label: '7 derniers jours' },
  { key: '30d', label: '30 derniers jours' },
  { key: 'month', label: 'Ce mois-ci' },
  { key: 'custom', label: 'Personnalisée' },
];

const iso = (d) => d.toISOString().slice(0, 10);
export const periodRange = (period, from, to) => {
  const now = new Date();
  const today = iso(now);
  if (period === 'today') return [today, today];
  if (period === '7d') return [iso(new Date(now - 6 * 864e5)), today];
  if (period === '30d') return [iso(new Date(now - 29 * 864e5)), today];
  if (period === 'month') return [`${today.slice(0, 8)}01`, today];
  if (period === 'custom') return [from || null, to || null];
  return [null, null];
};

export const eur = (v) => `${Number(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
export const fmtDay = (d) => {
  if (!d) return '—';
  const dt = new Date(String(d).length === 10 ? `${d}T12:00:00` : d);
  return Number.isNaN(dt.getTime()) ? String(d).slice(0, 10) : dt.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
};
export const fmtDateTime = (d) => (d ? new Date(d).toLocaleString('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—');
export const openDays = (a) => (a.first_seen_at ? Math.max(0, Math.floor((Date.now() - new Date(a.first_seen_at).getTime()) / 864e5)) : 0);
export const sortAlerts = (list) => [...list].sort((a, b) => (SEVERITY[a.severity]?.order ?? 9) - (SEVERITY[b.severity]?.order ?? 9)
  || String(b.element_date || '').localeCompare(String(a.element_date || '')));

export const ccApi = {
  summary: (refresh) => api.get(`/api/admin/control-center/summary${refresh ? '?refresh=true' : ''}`),
  alerts: (status = 'open') => api.get(`/api/admin/control-center/alerts?status=${status}`),
  history: (params) => api.get('/api/admin/control-center/history', { params }),
  claim: (keys, label) => api.post('/api/admin/control-center/alerts/claim', { keys, label }),
  ignore: (keys, note) => api.post('/api/admin/control-center/alerts/ignore', { keys, note }),
  reopen: (keys) => api.post('/api/admin/control-center/alerts/reopen', { keys }),
  mask: (keys, note) => api.post('/api/admin/control-center/alerts/mask', { keys, note }),
  unmask: (keys) => api.post('/api/admin/control-center/alerts/unmask', { keys }),
  run: (endpoint, method = 'POST', body) => api.request({ url: endpoint, method, data: body }),
};

export const errMsg = (e) => e?.response?.data?.detail || 'Erreur';
